import { render, staticRenderFns } from "./DealsByLeadBoard.vue?vue&type=template&id=5abc3659&scoped=true&"
import script from "./DealsByLeadBoard.vue?vue&type=script&lang=js&"
export * from "./DealsByLeadBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abc3659",
  null
  
)

export default component.exports